import styled from "styled-components";

export const InlineP = styled.p`
  display: inline;
  font-size: 14px;
  font-style: normal;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  line-height: 22px;
  margin-bottom: ${({ theme }) => theme.spacing.md};
  text-align: start;

  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
`;
